






























































































































































































































































































































































import { Component, Prop, Vue, Provide, Watch } from "vue-property-decorator";
import errorsUtil from "./../utils/errorMappings";
import _ from "lodash";

@Component({})
export default class BulkQuestionare extends Vue {
  @Provide("$api") $api: any;
  @Provide("$_") $_: any;

  @Prop() private accountId!: string;
  @Prop() private companyId!: string;
  @Prop() private jobId!: string;

  private questionare: any = {};
  private jobDetails: any = {};

  private loading = false;

  private errorMessageTop = "";

  async mounted() {
    this.$store.commit("startLoading");
    this.loading = true;
    await this.getJobDetails();
    await this.getQuestionare();
    this.loading = false;
    this.$store.commit("stopLoading");
  }

  async getJobDetails() {
    try {
      const response = await this.$api.get(
        `item-classification-api/v1/jobs/${this.companyId}/${this.jobId}`
      );
      this.jobDetails = response.data;
    } catch (error) {
      this.$store.commit("stopLoading");
      this.loading = false;
      this.displayError(error);
    }
  }

  async getQuestionare() {
    try {
      const response = await this.$api.get(
        `item-classification-api/v1/jobs/${this.companyId}/${this.jobId}/questionnaire`
      );
      this.questionare = response.data;
    } catch (error) {
      this.$store.commit("stopLoading");
      this.loading = false;
      this.displayError(error);
    }
  }

  async saveAndNext() {
    try {
      this.$store.commit("startLoading");
      const saveResponse = await this.$api.put(
        `item-classification-api/v1/jobs/${this.companyId}/${this.jobId}/questionnaire`,
        this.questionare
      );
      if (
        this.jobDetails.metadata.support == "true" &&
        this.jobDetails.metadata.isQuestionnaireDone == "false"
      ) {
        const statusChangeResponse = await this.$api.post(
          `item-classification-api/v1/jobs/${this.companyId}/${this.jobId}/support`,
          null,
          { params: { notify: this.jobDetails?.metadata?.notify } }
        );
      }
      this.$store.commit("stopLoading");
      this.$emit("step-done");
    } catch (error) {
      this.$store.commit("stopLoading");
      this.displayError(error);
    }
  }

  @Watch("questionare", {
    immediate: true,
    deep: true,
  })
  private isSavePossible() {
    const companyQuestions: any[] = this.questionare.companyQuestions || [];
    const jobQuestions: any[] = this.questionare["jobQuestions"] || [];
    const allQuestions: any[] = companyQuestions.concat(jobQuestions);
    return (
      allQuestions.length > 0 &&
      allQuestions
        .filter((question) => question.required && this.showQuestion(question))
        .every((question) => {
          if (this.jobDetails.metadata.isQuestionnaireDone === "true") {
            return true;
          } else if (
            ["single", "singleArea", "date", "singleSelect"].indexOf(
              question.questionType
            ) >= 0
          ) {
            return (question.answer as string).trim() !== "";
          } else if (question.questionType === "multiSelect") {
            return (question.answer as Array<string>).length > 0;
          } else if (question.questionType === "multiQuestion") {
            return question.options.every((option) => option.answer != "");
          } else {
            return false;
          }
        })
    );
  }

  private areJobQuestionsPresent(questions: any[]) {
    return (
      questions &&
      questions.filter((question) => this.showQuestion(question)).length > 0
    );
  }

  private showQuestion(question: any) {
    const rules: any[] = question.rules;
    const herculeRole = this.$store.state.herculeRole;
    const featureLevel = this.$store.getters.featureLevel(
      "item-classification"
    );
    const basedOnRules = !rules
      ? true
      : rules.some(
          (rule) =>
            rule.featureLevel === featureLevel &&
            rule.roles.indexOf(herculeRole) >= 0
        );
    const basedOnSupport = !question.support
      ? true
      : question.support.toString() == this.jobDetails.metadata.support;
    return basedOnRules && basedOnSupport;
  }

  @Watch("errorMessageTop")
  focusErrorAlert() {
    if (this.errorMessageTop != "") {
      (this.$refs.questionareHeader as any).scrollIntoView();
    }
  }

  private displayError(error) {
    const errorCode = error.response.data.code;
    if (_.has(errorsUtil.errorMessages, errorCode)) {
      this.$store.commit("recordError", "");
      this.errorMessageTop = errorsUtil.errorMessages[errorCode];
    }
  }

  private previous() {
    (this.$parent as any).previousStep();
  }

  private cancel() {
    this.$router.push({
      path: `/classification/${this.accountId}/${this.companyId}/jobs`,
    });
  }

  private onSingleTextChange(e: any, type: string, questionIndex: number) {
    this.questionare = _.set(
      this.questionare,
      `${type}[${questionIndex}].answer`,
      e.target.value
    );
  }

  private onSingleSelectChange(e: any, type: string, questionIndex: number) {
    const targetValue: string = e.detail.item.value;
    this.questionare = _.set(
      this.questionare,
      `${type}[${questionIndex}].answer`,
      e.detail.item.value
    );
  }

  private onDateChange(e: any, type: string, questionIndex: number) {
    this.questionare = _.set(
      this.questionare,
      `${type}[${questionIndex}].answer`,
      e.detail.value
    );
  }

  private onMultiselectChange(
    e: any,
    type: string,
    questionIndex: number,
    isRemoved: boolean
  ) {
    const targetValue: string = e.detail.item.value;
    const currentValue: string[] =
      this.questionare[type][questionIndex].answer || [];
    const updatedValue = isRemoved
      ? currentValue.filter((item) => item != targetValue)
      : currentValue.concat(targetValue);
    this.questionare = _.set(
      this.questionare,
      `${type}[${questionIndex}].answer`,
      updatedValue
    );
  }

  private onMultiquestionChange(
    value: string,
    type: string,
    questionIndex: number,
    radioIndex: number
  ) {
    this.questionare = _.set(
      this.questionare,
      `${type}[${questionIndex}].options[${radioIndex}].answer`,
      value
    );
  }
}
